module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/data-entry-example/data-entry-example.component.scss
// module id = ./src/app/components/examples/data-entry-example/data-entry-example.component.scss
// module chunks = main